exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr .drag-cell {\r\n  text-align: center;\r\n}\r\n\r\ntr .drag-cell span {\r\n  /*pointer-events: none;*/\r\n  /*user-select: none;*/\r\n  /*user-drag: none;*/\r\n}\r\n\r\ndiv.dragging tr.k-master-row:hover {\r\n  background-color: inherit;\r\n}\r\n\r\ndiv.dragging .k-grid-table tbody tr:hover {\r\n  background-color: inherit !important;\r\n}\r\n\r\ndiv.dragging .k-grid-table tbody tr.k-state-selected {\r\n  background: var(--cyan-200) !important;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/drag-cell/styles.css
// module id = 2145
// module chunks = 29